import React from 'react';
import { useT } from '@repo/common';

import UploadPhoto from './PersonalInfo/UploadPhoto';
import PersonalInfoForm from './PersonalInfo/PersonalInfoForm';
import VisaInfoForm from './VisaInfo/VisaInfoForm';
import MobileVisaInfoForm from './VisaInfo/MobileVisaInfoForm';
import SummaryForm from './Summary/SummaryForm';
import StepTitle from '../Common/StepTitle';

const ProfileStep = ({ resumeData, setResumeData, $isMobile }) => {
  const t = useT();
  return (
    <div>
      <div className='w-full flex flex-col items-start pb-[28px] md:pb-[30px]'>
        <StepTitle
          title={t('Personal Info', '인적 사항')}
          required={true}
          $isMobile={$isMobile}
        />
        <div className={`w-full flex flex-col md:flex-row items-start`}>
          <div className='flex-shrink-0 pb-3 md:pb-0'>
            <UploadPhoto
              profile={resumeData.profile}
              setResumeData={setResumeData}
            />
          </div>
          <div className='flex-1 min-w-0 w-full'>
            <PersonalInfoForm
              profile={resumeData.profile}
              setResumeData={setResumeData}
              $isMobile={$isMobile}
            />
          </div>
        </div>
      </div>

      <div className='w-full flex flex-col items-start pb-[28px] md:pb-[30px]'>
        <StepTitle
          title={t('Visa Info', '비자 정보')}
          required={true}
          $isMobile={$isMobile}
        />
        <div className='w-full flex items-start'>
          <div className='flex-1 min-w-0'>
            {$isMobile ? (
              <MobileVisaInfoForm
                visa={resumeData.visa}
                setResumeData={setResumeData}
              />
            ) : (
              <VisaInfoForm
                visa={resumeData.visa}
                setResumeData={setResumeData}
              />
            )}
          </div>
        </div>
      </div>

      <div className='w-full flex flex-col items-start'>
        <StepTitle title={t('Summary', '자기소개')} $isMobile={$isMobile} />
        <div className='w-full flex items-start'>
          <div className='flex-1 min-w-0'>
            <SummaryForm
              summary={resumeData.summary}
              setResumeData={setResumeData}
              $isMobile={$isMobile}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileStep;
